import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = {
  settings: () => axios.get(`${API}/settings`).then((r) => r.data),
  services: () => axios.get(`${API}/services`).then((r) => r.data),
  service: (slug) => axios.get(`${API}/services/${slug}`).then((r) => r.data),
  faq: (category) => axios.get(`${API}/faq`, { params: category ? { category } : {} }).then((r) => r.data),
  locations: () => axios.get(`${API}/locations`).then((r) => r.data),
  location: (slug) => axios.get(`${API}/locations/${slug}`).then((r) => r.data),
  testimonials: () => axios.get(`${API}/testimonials`).then((r) => r.data),
  createQuote: (payload) => axios.post(`${API}/quotes`, payload).then((r) => r.data),
  upload: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return axios.post(`${API}/uploads`, fd).then((r) => r.data);
  },
  fileUrl: (id) => `${API}/files/${id}`,
};
